import * as S from "./style";

export {};